import { getBaseHost, getApiBaseHost } from '@kulee/tga-constant';

let configs = {
  previewUrl(token, gameAppId, gameId, tags) {
    // let lang = localStorage.getItem('mp_lang') || 'en'
    let lang = "en";
    let env = process.env.SDP_ENV;

    let getUrl = `${getBaseHost(env)}/web/game/game-play.html`

    if (tags && tags.length > 0) {
      return (
        getUrl +
        "?game-type=pk&game-id=" +
        gameId +
        "&lang=" +
        lang +
        "&test=true&app-id=124cad5d6fe64b55862adbbffbd9e1af&env=" +
        env +
        "&ad-test=1&type=14&txn-id=1&game-url="
      );
    } else {
      return (
        getUrl +
        "?game-id=" +
        gameId +
        "&lang=" +
        lang +
        "&test=true&app-id=124cad5d6fe64b55862adbbffbd9e1af&env=" +
        env +
        "&ad-test=1&type=14&txn-id=1&game-url="
      );
    }

    // http://cdn.just4fun.sg/web/game/game-play.html?env=test&app-id=124cad5d6fe64b55862adbbffbd9e1af&txn-id=1&game-id=77&test=true&lang=en&ad-test=1&theme=bip
  },
  newPreviewUrl(gameId, type) {
    let lang = "en";
    let url = location.host;
    let env = process.env.SDP_ENV;

    let getUrl = `${getBaseHost(env)}/tga-h5/game-play.html`


    if (type == 1) {
      return (
        getUrl +
        "?game-type=pk&game-id=" +
        gameId +
        "&lang=" +
        lang +
        "&test=true&app-id=124cad5d6fe64b55862adbbffbd9e1af&env=" +
        env +
        "&ad-test=1&type=14&txn-id=1&game-url="
      );
    } else {
      return (
        getUrl +
        "?game-id=" +
        gameId +
        "&lang=" +
        lang +
        "&test=true&app-id=124cad5d6fe64b55862adbbffbd9e1af&env=" +
        env +
        "&ad-test=1&type=14&txn-id=1&game-url="
      );
    }

    // http://cdn.just4fun.sg/web/game/game-play.html?env=test&app-id=124cad5d6fe64b55862adbbffbd9e1af&txn-id=1&game-id=77&test=true&lang=en&ad-test=1&theme=bip
  },
  serviceEmail() {
    return "958236507@qq.com";
  },
  // 不需要登录也可以打开的页面
  noLogin() {
    return ["/contact"];
  },

  NewData(data) {
    var d = new Date(data);
    var year = d.getFullYear(); //年
    var month = d.getMonth() + 1; //月
    var day = d.getDate(); //日
    var hh = d.getHours(); //时
    var mm = d.getMinutes(); //分
    var ss = d.getSeconds(); //秒
    var clock = year + "-";
    if (month < 10) clock += "0";
    clock += month + "-";
    if (day < 10) clock += "0";
    clock += day + " ";
    if (hh < 10) clock += "0";
    clock += hh + ":";
    if (mm < 10) clock += "0";
    clock += mm + ":";
    if (ss < 10) clock += "0";
    clock += ss;
    return clock;
  }
};

export default configs;



// WEBPACK FOOTER //
// ./src/utils/config.js